import React, { useRef, useState } from "react";
import { toast } from "react-toastify";
import { base_url } from "../../../utils/AxiosConfig";
import axios from "axios";
import dayjs from "dayjs";
import SnackbarNotification from "../../../utils/SnackbarNotification";

const AddTimeSheetPopup = ({ popUpData }) => {
  const storedUserDataArray =
    JSON.parse(localStorage.getItem("BondTimeuserDataArray")) || [];
  let companyCode = null;

  if (storedUserDataArray) {
    companyCode = storedUserDataArray[0].cmpcode;
  }

  // const [timeSheetData, setTimeSheetData] = useState({
  //   startDate: "",
  //   endDate: ""
  // })

  const [timeSheetData, setTimeSheetData] = useState({
    startDate: dayjs().format("dd-MMM-yyyy"),
    endDate: dayjs().format("dd-MMM-yyyy"),
  });

  const [isLoading, setIsLoading] = useState(false);

  // Handle input change
  const handleChange = (e) => {
    const { name, value } = e.target;
    setTimeSheetData({
      ...timeSheetData,
      [name]: value,
    });
  };

  const modalRef = useRef();

  // Handle form submission
  const handleSubmit = async () => {
    setIsLoading(true);
    try {
      const payload = [
        {
          mode: "ENTRY",
          cmpcode: companyCode,
          Empid: popUpData?.EmpId,
          StartDate: timeSheetData.startDate,
          EndDate: timeSheetData.endDate,
          deptno: "-",
          jobcode: "-",
        },
      ];

      console.log("payload ", payload);
      console.log("Final URL:", `${base_url}api/TimesheetReg`);
      const response = await axios.post(
        `${base_url}/api/TimesheetReg`,
        payload,
        {
          headers: {
            "Content-Type": "application/json",
          },
        },
      );
      console.log("response:", response);

      if (response.status === 200) {
        // toast.success("Timesheet submitted successfully!");
        showSnackbar("success", "Timesheet generated successfully");
        // setTimeSheetData({
        //   startDate: "",
        //   endDate: ""
        // })

        // Close the modal
        // const modal = bootstrap.Modal.getInstance(modalRef.current);
        // if (modal) {
        //   modal.hide();
        // }
      } else {
        // toast.error("Failed to submit timesheet.");
        showSnackbar("error", "Failed to generate timesheet.");
      }
    } catch (error) {
      console.error("Axios error:", error);
      toast.error(
        error?.response?.data?.message ||
          error.message ||
          "An error occurred while submitting timesheet.",
      );
    } finally {
      setIsLoading(false);
    }
  };

  const [snackbar, setSnackbar] = useState({
    open: false,
    severity: "success",
    message: "",
  });

  const showSnackbar = (severity, message) => {
    setSnackbar({ open: true, severity, message });
  };

  const handleClose = () => {
    setSnackbar({ ...snackbar, open: false });
  };

  return (
    <div>
      <div
        class="modal fade"
        id="staticBackdrop"
        data-bs-backdrop="static"
        data-bs-keyboard="false"
        tabindex="-1"
        aria-labelledby="staticBackdropLabel"
        aria-hidden="true"
        ref={modalRef}
      >
        <div class="modal-dialog modal-lg">
          <div class="modal-content">
            <div class="modal-header">
              <h1
                class="modal-title  text-secondary fs-small"
                id="staticBackdropLabel"
              >
                Add Timesheet (timesheet)
              </h1>
              <button
                type="button"
                class="btn-close"
                data-bs-dismiss="modal"
                aria-label="Close"
              ></button>
            </div>
            <div class="modal-body">
              <div className="container-fluid">
                <div className="row">
                  <div className="col-md-6">
                    <div class="mb-3">
                      <label
                        for="exampleInputEmail1"
                        class="form-label fs-small text-secondary"
                      >
                        Emp ID
                      </label>
                      <input
                        type="text"
                        class="form-control"
                        value={popUpData?.EmpId}
                        disabled
                      />
                    </div>
                    <div class="mb-3">
                      <label
                        for="exampleInputEmail1"
                        class="form-label fs-small text-secondary"
                      >
                        Emp Name
                      </label>
                      <input
                        type="text"
                        class="form-control"
                        value={popUpData?.Name}
                        disabled
                      />
                    </div>

                    <div class="mb-3">
                      <label
                        for="exampleInputEmail1"
                        class="form-label fs-small text-secondary"
                      >
                        Designation
                      </label>
                      <input
                        type="text"
                        class="form-control"
                        value={popUpData?.JobTitle}
                        disabled
                      />
                    </div>
                    {/* <div class="mb-3">
                      <label for="exampleInputEmail1" class="form-label fs-small text-secondary">Date</label>
                      <input type="text" class="form-control" disabled />

                    </div> */}
                  </div>
                  <div className="col-md-6">
                    {/* <div class="mb-3">
                      <label for="exampleInputEmail1" class="form-label fs-small text-secondary">Time</label>
                      <input type="text" class="form-control" disabled />

                    </div> */}

                    {/* 
                    <div class="mb-3">
                      <label for="exampleInputEmail1" class="form-label fs-small text-secondary">Department</label>
                      <input type="text" class="form-control" />

                    </div> */}

                    <div class="mb-3">
                      <label
                        for="exampleInputEmail1"
                        class="form-label fs-small text-secondary"
                      >
                        Start Date
                      </label>
                      <input
                        type="date"
                        class="form-control"
                        id="startDate"
                        name="startDate"
                        value={timeSheetData.startDate}
                        onChange={handleChange}
                        max={new Date().toISOString().split("T")[0]}
                      />
                    </div>

                    <div class="mb-3">
                      <label
                        for="exampleInputEmail1"
                        class="form-label fs-small text-secondary"
                      >
                        End Date
                      </label>
                      <input
                        type="date"
                        class="form-control"
                        id="endDate"
                        name="endDate"
                        value={timeSheetData.endDate}
                        onChange={handleChange}
                        max={new Date().toISOString().split("T")[0]}
                      />
                    </div>

                    {/* <div class="mb-3">
                      <label for="exampleInputEmail1" class="form-label fs-small text-secondary">Grade</label>
                      <input type="text" class="form-control" />

                    </div> */}
                  </div>
                </div>
              </div>
            </div>
            <div class="modal-footer">
              <button
                className="btn btn-primary"
                onClick={handleSubmit}
                disabled={isLoading}
              >
                {isLoading ? "Submitting..." : "Submit"}
              </button>
            </div>
          </div>
        </div>
      </div>
      <SnackbarNotification
        open={snackbar.open}
        severity={snackbar.severity}
        message={snackbar.message}
        onClose={handleClose}
      />
    </div>
  );
};

export default AddTimeSheetPopup;
